exports._toFixed = function (decimals) {
  return function (value) {
    return Number(Number.parseFloat(value).toFixed(decimals));
  };
};
